"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var baseTheme = require("../../styles/baseForm.scss");
var theme = require("./theme.scss");
var containers_1 = require("../../containers");
var ui_1 = require("@vidazoo/ui");
var mobx_react_1 = require("mobx-react");
var components_1 = require("./components");
var NotificationSettings = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationSettings, _super);
    function NotificationSettings(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.renderPhoneWarningMessage = function () {
            var _a = _this.props.profileStore, item = _a.item, isLoadingProfile = _a.isLoading;
            var _b = _this.props.userNotificationsSettingsStore, filteredItems = _b.filteredItems, isLoading = _b.isLoading;
            if (!isLoading && filteredItems && filteredItems.length && !isLoadingProfile && !item.phone) {
                return React.createElement("div", null,
                    React.createElement(ui_1.PanelMessage, { message: _this.getPhoneWarningMessage() }));
            }
        };
        _this.getPhoneWarningMessage = function () {
            var open = _this.props.profileStore.open;
            var onClick = function () { return open(); };
            return React.createElement("div", null,
                "Please add your phone number to enable text message notifications. ",
                React.createElement("strong", { className: theme.link, onClick: onClick }, "Click here to update your profile."));
        };
        _this.cancelDeleteItem = function () {
            var setPromptDeleteItem = _this.props.userNotificationsSettingsStore.setPromptDeleteItem;
            setPromptDeleteItem(null);
        };
        props.userNotificationsSettingsStore.reset();
        props.userNotificationsSettingsStore.getItems(props.currentUserStore._id);
        return _this;
    }
    NotificationSettings.prototype.componentDidMount = function () {
        var profileStore = this.props.profileStore;
        profileStore.getItem();
    };
    NotificationSettings.prototype.renderLoader = function () {
        return (React.createElement("div", { className: theme.pageMessageContainer },
            React.createElement("div", { className: baseTheme.message },
                React.createElement(ui_1.Loader, { size: 1, gray: true, className: baseTheme.loader }),
                React.createElement(ui_1.PageMessage, { small: true, title: "Loading Notifications Settings", description: "Please wait..." }))));
    };
    NotificationSettings.prototype.renderError = function () {
        return (React.createElement("div", { className: theme.pageMessageContainer },
            React.createElement("div", { className: baseTheme.message },
                React.createElement(ui_1.PageMessage, { small: true, title: "Failed to load Notifications Settings", description: "We had an error loading the requested page.", iconName: "icon-rejected-status" }))));
    };
    NotificationSettings.prototype.render = function () {
        var _a = this.props, userNotificationsSettingsStore = _a.userNotificationsSettingsStore, profileStore = _a.profileStore;
        var filteredItems = userNotificationsSettingsStore.filteredItems, isLoading = userNotificationsSettingsStore.isLoading, loadError = userNotificationsSettingsStore.loadError, updateSetting = userNotificationsSettingsStore.updateSetting, sortBy = userNotificationsSettingsStore.sortBy, sortDirection = userNotificationsSettingsStore.sortDirection, searchQueries = userNotificationsSettingsStore.searchQueries, setPromptDeleteItem = userNotificationsSettingsStore.setPromptDeleteItem, density = userNotificationsSettingsStore.density, loadMore = userNotificationsSettingsStore.loadMore, setColumnsWidth = userNotificationsSettingsStore.setColumnsWidth, getColumnsWidth = userNotificationsSettingsStore.getColumnsWidth, setSearchQuery = userNotificationsSettingsStore.setSearchQuery, sort = userNotificationsSettingsStore.sort, promptDeleteItem = userNotificationsSettingsStore.promptDeleteItem, deleteItem = userNotificationsSettingsStore.deleteItem;
        var item = profileStore.item;
        return (React.createElement(ui_1.PageContainer, { pageTitle: "Notification Settings", className: theme.pageContainer, style: { padding: "0" } },
            React.createElement("div", { className: theme.pageTitle },
                React.createElement(ui_1.PageTitle, { iconName: "icon-settings", label: "Notification Settings" }),
                this.renderPhoneWarningMessage()),
            !loadError ?
                React.createElement("div", { className: theme.container },
                    !isLoading ? (React.createElement(components_1.List, { items: filteredItems, updateSetting: updateSetting, phone: item.phone, sortBy: sortBy, sortDirection: sortDirection, searchQueries: searchQueries, onDelete: setPromptDeleteItem, onSearch: setSearchQuery, onSort: sort, density: density, loadMore: loadMore, setColumnsWidth: setColumnsWidth, getColumnsWidth: getColumnsWidth })) : null,
                    isLoading ? this.renderLoader() : null,
                    loadError ? this.renderError() : null)
                : null,
            React.createElement(ui_1.Modal, { external: true, exitOnClickOutside: true, onClose: this.cancelDeleteItem, isOpen: !!promptDeleteItem },
                React.createElement(ui_1.ConfirmPopMessage, { red: true, title: "Delete Notification Setting", text: React.createElement("span", null,
                        "Are you sure you want to delete ",
                        promptDeleteItem ? React.createElement(ui_1.Label, { weight: 600, block: false }, "" + promptDeleteItem.name) : "",
                        "?"), cancelText: "No, Cancel", confirmText: "Yes, Delete", onCancelClick: this.cancelDeleteItem, onConfirmClick: deleteItem }))));
    };
    NotificationSettings.defaultProps = {};
    NotificationSettings = tslib_1.__decorate([
        mobx_react_1.observer
    ], NotificationSettings);
    return NotificationSettings;
}(containers_1.BaseContainer));
exports.default = NotificationSettings;
